var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { getAirtableName, } from "../constants/constants";
import { useGlobalState } from "../store/store";
var API_KEY = process.env.REACT_APP_AIRTABLE_API_KEY;
var BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;
export var useHistoricalData = function (vaultOption) {
    var airtableName = getAirtableName(vaultOption);
    var API_URL = "https://api.airtable.com/v0/" + BASE_ID + "/" + airtableName + "?sort%5B0%5D%5Bfield%5D=Timestamp&sort%5B0%5D%5Bdirection%5D=asc";
    var _a = useState({
        fetched: false,
        res: [],
    }), data = _a[0], setData = _a[1];
    var fetchAirtableData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, weeklyYields, cumYield, formattedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get(API_URL, {
                        headers: {
                            Authorization: "Bearer " + API_KEY,
                        },
                    })];
                case 1:
                    response = _a.sent();
                    data = response.data.records;
                    weeklyYields = data.map(function (row) { return row.fields.WeeklyYield * 100; });
                    cumYield = [];
                    weeklyYields.reduce(function (a, b, i) { return (cumYield[i] = a + b); }, 0);
                    formattedData = data.map(function (row, index) {
                        var formatted = {
                            apy: row.fields.APY * 100,
                            premiums: row.fields.Premiums,
                            principal: row.fields.Principal,
                            timestamp: row.fields.Timestamp,
                            yield: row.fields.WeeklyYield,
                            cumYield: cumYield[index],
                        };
                        return formatted;
                    });
                    setData({
                        fetched: true,
                        res: formattedData,
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [API_URL]);
    useEffect(function () {
        fetchAirtableData();
    }, [fetchAirtableData]);
    return data;
};
export var useLatestAPY = function (vaultOption) {
    var _a = useGlobalState("latestAPY"), latestAPY = _a[0], setLatestAPY = _a[1];
    var fetchAirtableData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, newApy;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (latestAPY[vaultOption].fetched) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, axios.get("https://api.airtable.com/v0/" + BASE_ID + "/" + getAirtableName(vaultOption) + "?sort%5B0%5D%5Bfield%5D=Timestamp&sort%5B0%5D%5Bdirection%5D=desc&maxRecords=1", {
                            headers: {
                                Authorization: "Bearer " + API_KEY,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    data = response.data.records;
                    newApy = data[0].fields.APY * 100;
                    setLatestAPY(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[vaultOption] = { apy: newApy, fetched: true }, _a)));
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [vaultOption, latestAPY, setLatestAPY]);
    useEffect(function () {
        fetchAirtableData();
    }, [fetchAirtableData]);
    return {
        fetched: latestAPY[vaultOption].fetched,
        res: latestAPY[vaultOption].apy,
    };
};
export var useLatestAPYs = function (vaultOptions) {
    var _a = useGlobalState("latestAPY"), latestAPY = _a[0], setLatestAPY = _a[1];
    var fetchAirtableData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            vaultOptions.forEach(function (vaultOption) { return __awaiter(void 0, void 0, void 0, function () {
                var response, data, newApy;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (latestAPY[vaultOption].fetched) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, axios.get("https://api.airtable.com/v0/" + BASE_ID + "/" + getAirtableName(vaultOption) + "?sort%5B0%5D%5Bfield%5D=Timestamp&sort%5B0%5D%5Bdirection%5D=desc&maxRecords=1", {
                                    headers: {
                                        Authorization: "Bearer " + API_KEY,
                                    },
                                })];
                        case 1:
                            response = _a.sent();
                            data = response.data.records;
                            newApy = data[0].fields.APY * 100;
                            setLatestAPY(function (prev) {
                                var _a;
                                return (__assign(__assign({}, prev), (_a = {}, _a[vaultOption] = { apy: newApy, fetched: true }, _a)));
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); }, [vaultOptions, latestAPY, setLatestAPY]);
    useEffect(function () {
        fetchAirtableData();
    }, [fetchAirtableData]);
    return Object.fromEntries(vaultOptions.map(function (vaultOption) { return [
        vaultOption,
        {
            fetched: latestAPY[vaultOption].fetched,
            res: latestAPY[vaultOption].apy,
        },
    ]; }));
};
//# sourceMappingURL=useAirtableData.js.map